import {
  GEOCODE_SET_SEARCH_TERM,
  GEOCODE_SET_SEARCH_RESULTS,
  GEOCODE_RESET,
} from './geocodeActions';

const initState = {searchTerm: '', results: []};
const geocode = (state = initState, action) => {
  switch (action.type) {
    case GEOCODE_RESET:
      return initState;
    case GEOCODE_SET_SEARCH_TERM:
      return {
        ...state,
        searchTerm: action.payload.searchTerm
      }
    case GEOCODE_SET_SEARCH_RESULTS:
      return {
        ...state,
        results: action.payload.results,
      }
    default:
      return state
  }
}

export default geocode


// WEBPACK FOOTER //
// ./src/shared/geocode/geocodeReducer.js